import React, { Fragment, useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Link,
  useHistory,
} from "react-router-dom";
import { Button } from "react-bootstrap";
import { db } from "../../../../firebase";
import {
  collection,
  query,
  orderBy,
  where,
  and,
} from "firebase/firestore";

import PageTitle from "../../../layouts/PageTitle";
import ApproverItem from "./ApproverItem";
import ApproverRegister from "./ApproverRegister";
import ApproverEdit from "./ApproverEdit";

import { usePagination } from "../../../../hook/usePagination";
import { useFirestore } from "../../../../hook/useFirestore";
import { useQuery } from "../../../../hook/useQuery";

const ApproverList = () => {
  const [approverItemList, setApproverItemList] = useState([]);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [itemEdit, setItemEdit] = useState({});

  const history = useHistory();
  const searchParams = useQuery();
  const param = searchParams.get("q");

  const searchRef = useRef(null);

  let QueryFilterConstraint = [];
  let queryRef = query(collection(db, "approvers"), orderBy("name", "asc"));

  if (param !== null) {
    QueryFilterConstraint.push(
      where("name", ">=", param),
      where("name", "<=", param + "\uf8ff")
    );

    queryRef = query(
      collection(db, "approvers"),
      and(...QueryFilterConstraint),
      orderBy("name", "asc")
    );
  }

  const {
    items: approverInfo,
    isLoading,
    isStart,
    isEnd,
    getPrev,
    getNext,
  } = usePagination(queryRef, { limit: 20 });

  const { deleteDocument } = useFirestore("approvers");

  const handleSearchChange = () => {
    history.replace({
      search: new URLSearchParams({ q: searchRef.current.value }).toString(),
    });
  };

  const handleOnNewItem = () => {
    setShowRegisterModal(true);
  };

  const handleOnEdit = async (id) => {
    setItemEdit(approverItemList.find((c) => c.id === id));
    setShowEditModal(true);
  };

  const handleOnRegisterHide = () => {
    setShowRegisterModal(false);
  };

  const handleOnEditHide = () => {
    setShowEditModal(false);
  };

  const handleOnDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        deleteDocument(id)
          .then(() => {
            swal(`Poof! Your file has been deleted!`, {
              icon: "success",
            });
          })
          .catch((err) => {
            swal(`Poof! ${err}`, {
              icon: "error",
            });
          });
      } else {
        swal("Canceled");
      }
    });
  };

  useEffect(() => {
    setApproverItemList(approverInfo);
  }, [approverInfo]);

  return (
    <Fragment>
      <PageTitle activeMenu="Approver List" motherMenu="Items" />
      <div className="form-head d-flex mb-3 mb-lg-5 align-items-center">
        <Button
          onClick={handleOnNewItem}
          className="btn btn-danger"
          data-toggle="tooltip"
          data-placement="top"
          title="Approver Registration"
        >
          + New Approver
        </Button>

        <div className="input-group search-area ml-auto d-inline-flex">
          <input
            type="text"
            className="form-control"
            placeholder="Search Name"
            onChange={handleSearchChange}
            ref={searchRef}
          />
          <div className="input-group-append">
            <span className="input-group-text c-pointer">
              <i className="flaticon-381-search-2"></i>
            </span>
          </div>
        </div>
      </div>
      <ApproverRegister
        show={showRegisterModal}
        hide={handleOnRegisterHide}
      />
      <ApproverEdit
        item={itemEdit}
        show={showEditModal}
        hide={handleOnEditHide}
      />
      <ApproverItem
        items={approverItemList}
        onEdit={handleOnEdit}
        onDelete={handleOnDelete}
      />
    </Fragment>
  );
};

export default ApproverList;
